<dialog class="modal" [open]="open">
  <div class="modal-box paper-modal max-w-3xl">
    <h3 class="h2 mb-3 flex items-center gap-2"><span class="text-primary">📊</span> Statistiken</h3>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-3 items-end">
      <div class="form-control md:col-span-2">
        <label class="label"><span class="label-text">Spieler filtern</span></label>
        <input class="input input-bordered" [(ngModel)]="filter" (ngModelChange)="onFilterChange()" placeholder="Name eingeben..." />
        <div class="text-xs opacity-60 mt-1">Automatische Filterung nach kurzer Zeit</div>
      </div>
      <div class="text-right">
        <button class="btn" (click)="close()">Schließen</button>
      </div>
    </div>

    <div class="mt-4 overflow-x-auto max-h-[70vh]">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>Platz</th>
            <th>Spieler</th>
            <th class="text-right">Ø Punkte</th>
            <th class="text-right">Höchste Wertung</th>
            <th class="text-right">Spiele</th>
            <th class="text-right">Siege</th>
          </tr>
        </thead>
        <tbody>
          @for (r of rows; track r; let i = $index) {
            @if (i < 3) {
              <tr [class.bg-gold]="i===0" [class.bg-silver]="i===1" [class.bg-bronze]="i===2" class="text-base-content/90">
                <td class="font-bold">
                  @if (i===0) {
                    <span>🥇</span>
                  }
                  @if (i===1) {
                    <span>🥈</span>
                  }
                  @if (i===2) {
                    <span>🥉</span>
                  }
                  <span class="ml-1">{{ i+1 }}</span>
                </td>
                <td class="font-semibold">{{ r.name }}</td>
                <td class="text-right font-extrabold">{{ r.averageScore }}</td>
                <td class="text-right">{{ r.bestScore }}</td>
                <td class="text-right">{{ r.games }}</td>
                <td class="text-right">{{ r.wins }}</td>
              </tr>
            }
            @if (i===2) {
              <tr>
                <td colspan="6" class="py-1"></td>
              </tr>
            }
            @if (i>=3) {
              <tr>
                <td class="opacity-80">{{ i+1 }}</td>
                <td>{{ r.name }}</td>
                <td class="text-right font-semibold">{{ r.averageScore }}</td>
                <td class="text-right">{{ r.bestScore }}</td>
                <td class="text-right">{{ r.games }}</td>
                <td class="text-right">{{ r.wins }}</td>
              </tr>
            }
          }
          @if (rows.length===0) {
            <tr>
              <td colspan="6" class="opacity-70">Keine Spieler gefunden.</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</dialog>
